import { TPageName } from 'shared/common/types/applicationContext';

export async function importApp(pageName: TPageName) {
  switch (pageName) {
    case 'regions': {
      return (await import('shared/regions/containers/App')).RegionsApp;
    }
    case 'main': {
      return (await import('shared/mainPage/containers/App')).MainApp;
    }

    default:
      throw new Error('Unknown context.custom.pageName');
  }
}
